// Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <footer className="text-center text-zinc-500 border-t border-zinc-700 pt-8 mt-8">
      <p>&copy; 2026 Gary Pinkley. All rights reserved.</p>
              <section className="max-w-2xl mx-auto flex justify-center pt-2 pb-2">
          <img
            src="Old/images/GaryPinkley25.jpg"
            alt="Gary Pinkley"
            className="rounded-xl shadow-lg w-32 h-32 object-cover"
          />
        </section>
    </footer>
  );
}
